"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifierRef = exports.OperandRef = exports.FunctionRef = exports.FunctionDef = exports.ExpressionRef = exports.ExpressionDef = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var ExpressionDef = /** @class */ (function (_super) {
    __extends(ExpressionDef, _super);
    function ExpressionDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.context = json.context;
        _this.expression = (0, builder_1.build)(json.expression);
        return _this;
    }
    ExpressionDef.prototype.exec = function (ctx) {
        var value = this.expression != null ? this.expression.execute(ctx) : undefined;
        ctx.rootContext().set(this.name, value);
        return value;
    };
    return ExpressionDef;
}(expression_1.Expression));
exports.ExpressionDef = ExpressionDef;
var ExpressionRef = /** @class */ (function (_super) {
    __extends(ExpressionRef, _super);
    function ExpressionRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    ExpressionRef.prototype.exec = function (ctx) {
        ctx = this.library ? ctx.getLibraryContext(this.library) : ctx;
        var value = ctx.get(this.name);
        if (value instanceof expression_1.Expression) {
            value = value.execute(ctx);
        }
        return value;
    };
    return ExpressionRef;
}(expression_1.Expression));
exports.ExpressionRef = ExpressionRef;
var FunctionDef = /** @class */ (function (_super) {
    __extends(FunctionDef, _super);
    function FunctionDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.expression = (0, builder_1.build)(json.expression);
        _this.parameters = json.operand;
        return _this;
    }
    FunctionDef.prototype.exec = function (_ctx) {
        return this;
    };
    return FunctionDef;
}(expression_1.Expression));
exports.FunctionDef = FunctionDef;
var FunctionRef = /** @class */ (function (_super) {
    __extends(FunctionRef, _super);
    function FunctionRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    FunctionRef.prototype.exec = function (ctx) {
        var functionDefs, child_ctx;
        if (this.library) {
            var lib = ctx.get(this.library);
            functionDefs = lib ? lib.getFunction(this.name) : undefined;
            var libCtx = ctx.getLibraryContext(this.library);
            child_ctx = libCtx ? libCtx.childContext() : undefined;
        }
        else {
            functionDefs = ctx.get(this.name);
            child_ctx = ctx.childContext();
        }
        var args = this.execArgs(ctx);
        // Filter out functions w/ wrong number of arguments.
        functionDefs = functionDefs.filter(function (f) { return f.parameters.length === args.length; });
        // If there is still > 1 matching function, filter by argument types
        if (functionDefs.length > 1) {
            functionDefs = functionDefs.filter(function (f) {
                var match = true;
                for (var i = 0; i < args.length && match; i++) {
                    if (args[i] !== null) {
                        var operandTypeSpecifier = f.parameters[i].operandTypeSpecifier;
                        if (operandTypeSpecifier == null && f.parameters[i].operandType != null) {
                            // convert it to a NamedTypedSpecifier
                            operandTypeSpecifier = {
                                name: f.parameters[i].operandType,
                                type: 'NamedTypeSpecifier'
                            };
                        }
                        match = ctx.matchesTypeSpecifier(args[i], operandTypeSpecifier);
                    }
                }
                return match;
            });
        }
        // If there is still > 1 matching function, calculate a score based on quality of matches
        if (functionDefs.length > 1) {
            // TODO
        }
        if (functionDefs.length === 0) {
            throw new Error('no function with matching signature could be found');
        }
        // By this point, we should have only one function, but until implementation is completed,
        // use the last one (no matter how many still remain)
        var functionDef = functionDefs[functionDefs.length - 1];
        for (var i = 0; i < functionDef.parameters.length; i++) {
            child_ctx.set(functionDef.parameters[i].name, args[i]);
        }
        return functionDef.expression.execute(child_ctx);
    };
    return FunctionRef;
}(expression_1.Expression));
exports.FunctionRef = FunctionRef;
var OperandRef = /** @class */ (function (_super) {
    __extends(OperandRef, _super);
    function OperandRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        return _this;
    }
    OperandRef.prototype.exec = function (ctx) {
        return ctx.get(this.name);
    };
    return OperandRef;
}(expression_1.Expression));
exports.OperandRef = OperandRef;
var IdentifierRef = /** @class */ (function (_super) {
    __extends(IdentifierRef, _super);
    function IdentifierRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    IdentifierRef.prototype.exec = function (ctx) {
        // TODO: Technically, the ELM Translator should never output one of these
        // but this code is needed since it does, as a work-around to get queries
        // to work properly when sorting by a field in a tuple
        var lib = this.library ? ctx.get(this.library) : undefined;
        var val = lib ? lib.get(this.name) : ctx.get(this.name);
        if (val == null) {
            var parts = this.name.split('.');
            val = ctx.get(parts[0]);
            if (val != null && parts.length > 1) {
                var curr_obj = val;
                for (var _i = 0, _a = parts.slice(1); _i < _a.length; _i++) {
                    var part = _a[_i];
                    // _obj = curr_obj?[part] ? curr_obj?.get?(part)
                    // curr_obj = if _obj instanceof Function then _obj.call(curr_obj) else _obj
                    var _obj = void 0;
                    if (curr_obj != null) {
                        _obj = curr_obj[part];
                        if (_obj === undefined && typeof curr_obj.get === 'function') {
                            _obj = curr_obj.get(part);
                        }
                    }
                    curr_obj = _obj instanceof Function ? _obj.call(curr_obj) : _obj;
                }
                val = curr_obj;
            }
        }
        if (val instanceof Function) {
            return val.call(ctx.context_values);
        }
        else {
            return val;
        }
    };
    return IdentifierRef;
}(expression_1.Expression));
exports.IdentifierRef = IdentifierRef;
//# sourceMappingURL=reusable.js.map